export const PASSWORD_PROVIDER_NAME = 'Password';

export class LoginMethodDto {
    providerName!: string;
    displayName!: string;
}
